import {Component, OnInit} from '@angular/core';
import { AuthService } from 'src/app/@auth/auth.service';
import { AuthSessionDto, ROLE_WORKSPACE_USER } from 'src/app/app.models';
import { CluConfirmDialogService } from '../../clu-confirm-dialog/clu-confirm-dialog.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CoreService } from 'src/app/services/core.service';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { lastValueFrom } from 'rxjs';

@Component({
    selector: 'clu-permission-unauthorized',
    templateUrl: './clu-permission-unauthorized.component.html',
    styleUrls: ['./clu-permission-unauthorized.component.scss'],
})
export class CluPermissionUnauthorizedComponent implements OnInit {
    authSessionDto: AuthSessionDto | null = null;
    attemptUrl: string | null = null;

    constructor(
        private dialog: MatDialog,
        private authService: AuthService,
        private snackbar: MatSnackBar,
        private router: Router,
        private activatedRoute: ActivatedRoute
    ) {
        this.authSessionDto = authService.authenticatedSession$.value;
        this.activatedRoute.queryParams.subscribe(params => this.attemptUrl = params['redirectUrl']);
    }

    ngOnInit() {
    }

    async doLogout() {
        let redirectUrl = '/login';
        if (this.authSessionDto != null) {
            if (this.authSessionDto.ROLE_ID == ROLE_WORKSPACE_USER.USER_WORKSPACE) {
                this.authService.doSignoutFOAction();
                this.authService.doRemoveAuthSession();
            } else if (this.authSessionDto.ROLE_ID == ROLE_WORKSPACE_USER.ADMIN_WORKSPACE || this.authSessionDto.ROLE_ID == ROLE_WORKSPACE_USER.SUPER_ADMIN_WORKSPACE) {
                this.authService.doSignoutAdminAction();
                this.authService.doRemoveAuthSession();
                redirectUrl = "/cluadmin/login";
            } else {
                this.authService.doRemoveAuthSession();
            }
        }
        this.dialog.closeAll();
        this.snackbar.open("Déconnecté", undefined, { duration: 3000 });
        this.router.navigateByUrl(redirectUrl);
    }
}